<template>
  <v-layout
    row
    align-center
    wrap
    md12
  >
    <v-flex
      md1
      :xs12="!isDesktop"
    >
      <v-btn
        outline
        :fab="isDesktop"
        :round="!isDesktop"
        :block="!isDesktop"
        :small="isDesktop"
        color="primary"
        :disabled="isWeekPassed()"
        @click="changeWeek(-1)"
      >
        <v-icon medium>
          navigate_before
        </v-icon>
      </v-btn>
    </v-flex>
    <DateList
      :weeks-from-current="weeksFromCurrent"
      :is-desktop="isDesktop"
      :range="range"
      :form="form"
      @updateVisitTimes="$emit('updateVisitTimes')"
    />
    <v-flex
      md1
      :xs12="!isDesktop"
    >
      <v-btn
        outline
        :fab="isDesktop"
        :round="!isDesktop"
        :block="!isDesktop"
        :small="isDesktop"
        color="primary"
        @click="changeWeek(1)"
      >
        <v-icon medium>
          navigate_next
        </v-icon>
      </v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
import DateList from './DateList'

export default {
  name: 'AppointmentDatePicker',
  components: {
    DateList,
  },
  props: {
    date: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      range: this.getWeek(0),
      weeksFromCurrent: 0,
      isDesktop: true,
    }
  },
  watch: {
    date() {
      this.weeksFromCurrent = 0
      this.range = this.getWeek(0)
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    getWeek(weeksToAdd) {
      const dateRange = []
      const date = moment(this.date, 'YYYY-MM-DD').add(weeksToAdd, 'week')
      const fromDate = moment(date).startOf('isoWeek')
      const toDate = moment(date).endOf('isoWeek')
      while (fromDate.isBefore(toDate)) {
        dateRange.push(fromDate.format('YYYY-MM-DD'))
        fromDate.add(1, 'day')
      }
      return dateRange
    },
    changeWeek(weeksToAdd) {
      this.weeksFromCurrent = this.weeksFromCurrent + weeksToAdd
      this.range = this.getWeek(this.weeksFromCurrent)
    },
    isWeekPassed() {
      const now = moment()
      const displayedWeek = moment(this.date, 'YYYY-MM-DD').add(this.weeksFromCurrent, 'weeks')
      const endOfPreviousWeek = moment(displayedWeek).startOf('week')
      return endOfPreviousWeek.isBefore(now) && this.weeksFromCurrent < 1
    },
    handleResize() {
      this.isDesktop = window.innerWidth >= 900
    },
  },
}
</script>

<style scoped>

</style>
